(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Typography", [], factory);
	else if(typeof exports === 'object')
		exports["Typography"] = factory();
	else
		root["Typography"] = factory();
})(this, function() {
return 